import axios from "axios";
import config from "../config";
class Ex10Api {
  async getChannelById(channelId) {
      return axios.get(
         `${config.cdp.projectBaseUrl}/projects/channels/${channelId}/public`
      ); 
   
  
  }

  async getLIFFChannelDetailByChannelId(channelId) {
    return axios.get(
      `${config.cdp.projectBaseUrl}/projects/channels/liff`,
      {
        headers: {
          "x-api-key" : `${channelId}`
        },
      }
    );
  }

  async getPdpaByUserId(channelId, lineUserId) {
    return axios.get(
      `${config.cdp.apiPdpaUrl}/liff/pdpa/${channelId}/${lineUserId}`
    );
  }

  async allowPdpaByUserId(channelId, lineUserId, pdpaId, data) {
    return axios.post(
      `${config.cdp.apiPdpaUrl}/liff/pdpa/${channelId}/${pdpaId}/${lineUserId}`, 
      {
        "actions": data,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  async uploadFlie(data) {
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    return axios.post(`${config.cdp.apiUploadUrl}/public/file`, data, {
      headers: headers,
    });
  }

  async clickEndpointLinkByShortIdAndUtmNo(data) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(`${config.cdp.apiLinkUrl}/e/link/click`, data, {
      headers: headers,
    });
  }
  
  async subminUUIDandIdToken(data) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(`https://jgn93hxm-8019.asse.devtunnels.ms/link-tracking/v3/tracking/user`, data, {
      headers: headers,
    });
  }

  async getLinkDataEndUser(shortId) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.get(`${config.cdp.apiLinkUrl}/e/link/${shortId}`, {
      headers: headers,
    });
  }

  async updateLineAdminSync(accessToken, channelId, data) {
    const Authorization = accessToken ? `Bearer ${accessToken}` : "";
    const headers = {
      Authorization,
      "Content-Type": "application/json",
    };
    return axios.put(`${config.cdp.projectBaseUrl}/projects/channels/${channelId}/members/lineUserId`, data, {
      headers: headers,
    });
  }
}


const ex10Api = new Ex10Api();

export default ex10Api;
